import { useQuery } from '@apollo/client';
import type { ApolloError } from '@apollo/client';

import GetDegreeNameById from 'bundles/my-purchases-graphql/components/tabs/enhancers/GetDegreeNameById.graphql';
import type {
  GetDegreeNameById_DegreeNameFieldsFragment as DegreeFragmentType,
  GetDegreeNameByIdQuery as GetDegreeNameByIdQueryData,
  GetDegreeNameByIdQueryVariables,
} from 'bundles/my-purchases-graphql/components/tabs/enhancers/__generated__/GetDegreeNameById';

export type DegreeType = DegreeFragmentType | undefined | null;

type PropsFromGetSpecialization = {
  mdp?: DegreeType;
  loading: boolean;
  error?: ApolloError;
};

export const useGetDegreeNameById = ({
  degreeId,
  skip,
}: {
  degreeId?: string;
  skip?: boolean;
}): PropsFromGetSpecialization => {
  const { loading, error, data } = useQuery<GetDegreeNameByIdQueryData, GetDegreeNameByIdQueryVariables>(
    GetDegreeNameById,
    {
      variables: {
        degreeId: `${degreeId}`,
      },
      context: { clientName: 'gatewayGql' },
      skip: !degreeId || skip,
    }
  );

  return { loading, error, mdp: data?.Degree?.queryById };
};
